module.exports = __webpack_public_path__ + "static/media/Fig-7-3-SVG-600x800.fe0c77fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/Fig-7-3-SVG-600x800.svg
// module id = 733
// module chunks = 0